export default {"src":"/_next/static/media/blocked-teammates-black.4a5e63df.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};